/* Devroldan */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-under-developing',
  templateUrl: './under-developing.component.html',
  styleUrls: ['./under-developing.component.scss']
})
export class UnderDevelopingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
